exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\r\n * Applies styles for users in high contrast mode. Note that this only applies\r\n * to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\r\n * attribute, however Chrome handles high contrast differently.\r\n */\n/* Theme for the ripple elements.*/\n/** The mixins below are shared between mat-menu and mat-select */\n/**\r\n * This mixin adds the correct panel transform styles based\r\n * on the direction that the menu panel opens.\r\n */\n/* stylelint-disable material/no-prefixes */\n/* stylelint-enable */\n/**\r\n * This mixin contains shared option styles between the select and\r\n * autocomplete components.\r\n */\n:host .background {\n  background: url(" + require("../../../../assets/images/logos/facturtransp.png") + ") no-repeat;\n  background-position: center;\n  background-position-y: 10em;\n  background-position-x: 50em;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-size: 40%;\n  opacity: 0.8; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/main/content/sample/sample.component.scss
// module id = ../../../../../src/app/main/content/sample/sample.component.scss
// module chunks = main